import { render, staticRenderFns } from "./TerminateEmployeeWarningModal.vue?vue&type=template&id=2bd9e32e&scoped=true"
import script from "./TerminateEmployeeWarningModal.vue?vue&type=script&lang=js"
export * from "./TerminateEmployeeWarningModal.vue?vue&type=script&lang=js"
import style0 from "./TerminateEmployeeWarningModal.vue?vue&type=style&index=0&id=2bd9e32e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd9e32e",
  null
  
)

export default component.exports